//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { DigitalGiftCardLargeSVG } from './svg'

interface DigitalGiftCardLargeIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const DigitalGiftCardLargeIcon: React.FC<DigitalGiftCardLargeIconProps> = forwardRef<
  DigitalGiftCardLargeIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon
    ref={ref}
    boxSize={boxSize}
    as={DigitalGiftCardLargeSVG}
    sx={sx}
  />
))
